module.exports = __webpack_public_path__ + "img/right-circled-arrow.824f4a35.svg";